import { connect } from 'react-redux';

import _ from 'lodash';
//import moment from 'moment'

import React from 'react';

import { Grid } from 'semantic-ui-react';

import {
  setupColumns,
  addGroupColumn,
  removeGroupColumn,
  toggleGroupColumnSort,
  //reorderGroupColumn,
  changeSortColumn,
  toggleColumnVisibility,
  reorderColumn,
  updateFilter,
  showDefinedView,
  updateActivePage,
  updateNumItemsPerPage,
  fetchPageData,
} from '../Actions/DashboardActions';

import { configColumns } from './Config';

import { QHGrid } from './QHGrid';

//import PageHeader from '../../../Components/PageHeader'

const Fragment = React.Fragment;

/*
* Handlers To Implement
- handleResetFiltersToCustomView
- handleResetFiltersToDefaultView
- handleFiltersResetAll


*/
//const settingCacheName='OCTUSReactContractDashboardSettingsV1'
class DashboardView extends React.Component {
  state = {};

  showSaveSettingsSuccessful = () => {
    this.setState({ showSaveSettingsSuccessful: true });
  };
  hideSaveSettingsSuccessful = () => {
    this.setState({ showSaveSettingsSuccessful: false });
  };

  saveCurrentSettings = () => {
    const settings = JSON.stringify({
      grouping: this.props.grouping,
      sortBy: this.props.sortBy,
      sortOrder: this.props.sortOrder,
      itemsPerPage: this.props.itemsPerPage,

      columns: _.map(this.props.columns, (col) => {
        return {
          ID: col.ID,
          title: col.title,
          field: col.field,
          hidden: col.hidden,
        };
      }),

      filters: this.props.filters,
    });

    localStorage.setItem('TrilogyDupeSearchDashboardUserSettings', settings);
    this.showSaveSettingsSuccessful();
    setTimeout(() => {
      this.hideSaveSettingsSuccessful();
    }, 5000);
  };

  clearSavedSettings = () => {
    localStorage.removeItem('TrilogyDupeSearchDashboardUserSettings');
    this.props.handleResetFiltersToDefaultView();
  };

  componentWillMount() {
    this.props.setupColumns();
    this.props.handleResetFiltersToCustomView();
  }

  render() {
    const quickViews = [
      /*{
            name: 'All In Progress Contracts',
            view: {
                grouping: [],
                sortBy: null,
                sortOrder: null,
                generalSearch: '',
                activePage: 1,
                itemsPerPage: 30,
                filters: {
                    contract_status: {
                        value: [
                            'Contract negotiations in progress',
                            'Contract negotiations completed',
                            'Contract began circulating for signatures',
                            'Contract circulating for signatures',
                            'Contract circulating for signatures at Institution',
                            'Contract circulating for signatures at AbbVie'
                        ],
                        type: 'multiFilter'
                    }
                },
                columns: columns
            }
        }*/
    ];

    //additional information to pass into the cell template functions in case the template depends on iformation not available in the row data
    const additionalTemplateInfo = {};

    //To be used to apply styles to rows based on criteria in the data for that row
    const rowLevelStyleCalc = (item) => {
      return {};
    };

    return (
      <Fragment>
        {/*<PageHeader header="Trilogy Duplicate Search" header_icon="dashboard"/>*/}
        <Grid centered>
          <Grid.Column width={15}>
            <QHGrid
              authorization={this.props.authorization}
              columns={this.props.columns}
              pageData={this.props.pageData}
              filters={this.props.filters}
              activePage={this.props.activePage}
              itemsPerPage={this.props.itemsPerPage}
              totalPages={this.props.totalPages}
              totalRows={this.props.totalRows}
              sortBy={this.props.sortBy}
              sortOrder={this.props.sortOrder}
              grouping={this.props.grouping}
              loading={this.props.fetchingPageData}
              handleGroupBy={this.props.handleGroupBy}
              handleRemoveGroupBy={this.props.handleRemoveGroupBy}
              handleGroupSortToggle={this.props.handleGroupSortToggle}
              quickViews={quickViews}
              handleShowQuickView={this.props.handleShowQuickView}
              handleSort={this.props.handleSort}
              handleColumnVisibilityToggle={this.props.handleColumnVisibilityToggle}
              handleColumnReorder={this.props.handleColumnReorder}
              handleFilterUpdate={this.props.handleFilterUpdate}
              handlePageChange={this.props.handlePageChange}
              handleItemsPerPageChange={this.props.handleItemsPerPageChange}
              handleResetFiltersToCustomView={this.props.handleResetFiltersToCustomView}
              handleResetFiltersToDefaultView={this.props.handleResetFiltersToDefaultView}
              handleFiltersResetAll={this.props.handleFiltersResetAll}
              saveCurrentSettings={this.saveCurrentSettings}
              showSaveSettingsSuccessful={this.state.showSaveSettingsSuccessful}
              clearSavedSettings={this.clearSavedSettings}
              additionalTemplateInfo={additionalTemplateInfo}
              rowLevelStyleCalc={rowLevelStyleCalc}
              reloadData={this.props.fetchPageData}
            />
          </Grid.Column>
        </Grid>
      </Fragment>
    );
  }
}

//Binds the current Redux state to props that the sub component (DashboardView) uses
const mapStateToProps = (state, ownProps) => {
  return {
    authorization: state.authorization,

    grouping: _.get(state, 'dashboard.grouping') || [],
    sortBy: _.get(state, 'dashboard.sortBy') || null,
    sortOrder: _.get(state, 'dashboard.sortOrder') || null,
    activePage: _.get(state, 'dashboard.activePage') || 1,
    itemsPerPage: _.get(state, 'dashboard.itemsPerPage') || 30,
    columns: _.get(state, 'dashboard.columns') || [],

    pageData: _.get(state, 'dashboard.pageData') || [],
    totalPages: _.get(state, 'dashboard.totalPages') || 0,
    totalRows: _.get(state, 'dashboard.totalRows') || 0,
    filters: _.get(state, 'dashboard.filters') || [],
    fetchingPageData: _.get(state, 'dashboard.fetchingPageData') || false,
  };
};

//map actions to properties to allow subcomponents tp update state
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    handleGroupBy: (col) => {
      dispatch(addGroupColumn(col));
      dispatch(fetchPageData());
    },
    handleRemoveGroupBy: (col_id) => () => {
      dispatch(removeGroupColumn(col_id));
      dispatch(fetchPageData());
    },
    handleGroupSortToggle: (col_id) => () => {
      dispatch(toggleGroupColumnSort(col_id));
      dispatch(fetchPageData());
    },

    handleSort: (field) => () => {
      dispatch(changeSortColumn(field));
      dispatch(fetchPageData());
    },

    handleColumnVisibilityToggle: (col_id) => () => {
      dispatch(toggleColumnVisibility(col_id));
    },
    handleColumnReorder: (cur_idx, new_idx) => {
      dispatch(reorderColumn(cur_idx, new_idx));
    },

    handleFilterUpdate: (field, filter_type) => (value) => {
      dispatch(updateFilter(field, filter_type, value));
      dispatch(fetchPageData());
    },

    handlePageChange: (evt, data) => {
      dispatch(updateActivePage(data.activePage));
      dispatch(fetchPageData());
    },
    handleItemsPerPageChange: (evt, data) => {
      dispatch(updateNumItemsPerPage(data.value));
      dispatch(fetchPageData());
    },

    handleResetFiltersToDefaultView: () => {
      const view = {
        grouping: [],
        sortBy: null,
        sortOrder: null,
        activePage: 1,
        itemsPerPage: 15,
        filters: {},
        columns: configColumns,
      };
      dispatch(showDefinedView(view));
      dispatch(fetchPageData());
    },
    handleResetFiltersToCustomView: () => {
      var savedSettings = localStorage.getItem('TrilogyDupeSearchDashboardUserSettings');
      if (savedSettings === null) {
        dispatch(fetchPageData());
        return;
      }
      savedSettings = JSON.parse(savedSettings);

      const newColumns = _.filter(configColumns, (dbcol) => {
        return _.every(savedSettings.columns, (col) => {
          return col.ID !== dbcol.ID;
        });
      });

      const columns = _.concat(
        _.reduce(
          savedSettings.columns,
          function(result, col) {
            var validCol = _.find(configColumns, (dbcol) => {
              return dbcol.ID === col.ID;
            });

            if (!_.isUndefined(validCol)) {
              validCol.hidden = col.hidden;
              result.push(validCol);
            }
            return result;
          },
          []
        ),
        newColumns
      );

      const view = {
        grouping: savedSettings.grouping,
        sortBy: savedSettings.sortBy,
        sortOrder: savedSettings.sortOrder,
        activePage: 1,
        itemsPerPage: savedSettings.itemsPerPage,
        filters: savedSettings.filters,
        columns: columns, //savedSettings.columns
      };

      dispatch(showDefinedView(view));
      dispatch(fetchPageData());
    },
    handleFiltersResetAll: () => {
      const allVisColumns = _.map(configColumns, (col) => {
        if (col.menu !== false && col.hidden === true) {
          col.hidden = false;
        }
        return col;
      });
      const view = {
        grouping: [],
        sortBy: null,
        sortOrder: null,
        activePage: 1,
        itemsPerPage: 30,
        filters: {},
        columns: allVisColumns,
      };
      dispatch(showDefinedView(view));
      dispatch(fetchPageData());
    },

    handleShowQuickView: (view) => () => {
      dispatch(showDefinedView(view));
      dispatch(fetchPageData());
    },

    fetchPageData: () => {
      dispatch(fetchPageData());
    },

    setupColumns: () => {
      dispatch(setupColumns(configColumns));
    },
  };
};

//Boilerplate code to connect the subcomponent to the Redux state - automatically determines if the subcomponent should update when the state is updated
export const Dashboard = connect(mapStateToProps, mapDispatchToProps)(DashboardView);

export default Dashboard;



// WEBPACK FOOTER //
// ./src/Components/Dashboard.jsx